import { cn } from '@/lib/utils'

export type ClubSport = {
  slug: string
  name: string
  headline: string
  intro: string
  image: string
  credit: string
}

export const CLUB_SPORTS: readonly ClubSport[] = [
  {
    slug: 'chess',
    name: 'Chess',
    headline: 'Your chess academy, organised.',
    intro: 'Lessons, coaching batches, tournaments and student groups in one place.',
    image: '/sportx/chess.jpg',
    credit: 'KhubsuratInsaan / Wikimedia Commons (CC BY-SA 4.0)',
  },
  {
    slug: 'badminton',
    name: 'Badminton',
    headline: 'Run your badminton academy with ease.',
    intro: 'Bring training classes, court schedules, coaches and matches together.',
    image: '/sportx/badminton.jpg',
    credit: 'Mustafa Fatemi / Unsplash',
  },
  {
    slug: 'tennis',
    name: 'Tennis',
    headline: 'More time on court. Less time on admin.',
    intro: 'Keep lessons, class schedules, players and matches connected.',
    image: '/sportx/tennis.jpg',
    credit: 'jebin ephrimraj / Unsplash',
  },
  {
    slug: 'martial-arts',
    name: 'Martial Arts',
    headline: 'Build a stronger martial arts academy.',
    intro: 'Manage students, instructors, classes, gradings and events in one place.',
    image: '/sportx/martial-arts.jpg',
    credit: 'Roshan Upadhyaya / Wikimedia Commons (CC0)',
  },
  {
    slug: 'cricket',
    name: 'Cricket',
    headline: 'Run the academy behind the game.',
    intro: 'Bring coaching batches, practice schedules, teams and matches together.',
    image: '/sportx/cricket.jpg',
    credit: 'Patrick Hendry / Unsplash',
  },
  {
    slug: 'football',
    name: 'Football',
    headline: 'Keep every team and training session together.',
    intro: 'Connect coaches, players, classes, fixtures and the wider club.',
    image: '/sportx/football.jpg',
    credit: 'jebin ephrimraj / Unsplash',
  },
]

export const findClubSport = (value: string | null | undefined) => {
  const normalized = String(value ?? '').trim().toLowerCase()
  return CLUB_SPORTS.find((sport) => sport.slug === normalized || sport.name.toLowerCase() === normalized)
}

export function SportxWordmark({ tone = 'light', className }: { tone?: 'light' | 'dark'; className?: string }) {
  return (
    <span className={cn('text-2xl font-black tracking-[-0.08em]', tone === 'light' ? 'text-white' : 'text-[#0a1420]', className)}>
      SPORT<span className={tone === 'light' ? 'text-[#c9fa55]' : 'text-[#6d8d31]'}>X</span>
    </span>
  )
}
